import './Footer.scss'

import classNames from 'classnames'
import React from 'react'

const FooterAdmin: React.FC = () => {
  const currentYear = new Date().getFullYear()
  const classes = classNames('db-admin-footer')

  const goSite = () => {
    window.open('https://www.derinbilgi.com.tr', '_blank')
  }
  return (
    <footer className={classes}>
      <div style={{ cursor: 'pointer' }} onClick={goSite} className="footer-alignment">
        <div>{currentYear}&copy; Derin Bilgi Sistemleri</div>
        <div>All rights reserved.</div>
      </div>
    </footer>
  )
}

export default FooterAdmin
